import $ from 'jquery';

/**
 *
 * @param {object} options
 * @return {LastCommentsViewModel}
 */
export function init(options) {
    const o = {
        heightTarget: '.layout-content',
        commentsType: 'all',
        reviewType: null,
        ...options
    };

	return new LastCommentsViewModel(o.heightTarget, o.commentsType, o.reviewType);
}

class LastCommentsViewModel {
    _$wrapper = $('#commentsWrapper');

    needsLoading = true;
    allVisible = true;
    heightTarget = null;

	constructor(heightTarget, commentsType, reviewType) {
	    const commentsPerPage = 50;

	    this.heightTarget = $(heightTarget);

	    this._prepareCommentBlocks(this._$wrapper.children('.comment-item'));
	    this.fit();

		this._$wrapper.zInfiniteScroll(
            {
                selector: '.comment-item',
                checkViewport: false,
                enabled: () => {
                    if (!this.allVisible) {
                        this.fit();
                    }
                    return this.needsLoading && this.allVisible;
                },
                maxAutoloadPages: 100,
                loading: '#lastCommentsScrollLoader',
                fetch: (page, callback) => {
                    $.get(
                        this._$wrapper.data('load-url'),
                        {
                            offset: (page - 1) * commentsPerPage,
                            count: commentsPerPage,
                            comments_type: commentsType,
                            review_type: reviewType,
                            new_layout: 1
                        },
                        (response) => {
                            let $blocks = $(response['html']);
                            callback($blocks);
                        },
                        'json'
                    );
                },
                show: ($blocks) => {
                    $blocks = $blocks.filter('.comment-item');
                    this.fit();
                    this._$wrapper.append($blocks);
                    this._prepareCommentBlocks($blocks);
                    this.fit();
                    return $blocks.length
                }
            }
		);

		$(document).on('heightTargetUpdated', () => {
		    this.fit();
		});
	}

    _prepareCommentBlocks($blocks) {
        $blocks.each(function () {
            let $this = $(this);
            $this.data('height', $this.outerHeight(true));
        });
    }

    fit() {
        let $content = this.heightTarget;
        let $comments = this._$wrapper.children('.comment-item');

        let contentBottom = $content.offset().top + $content.outerHeight();
        let top = this._$wrapper.offset().top;
        let commentsBottom = top + this._$wrapper.outerHeight();
        let $item;
        let result = 0;

        let commentsHeight = this._$wrapper.outerHeight();

        if (commentsBottom > contentBottom) {
            // hide elements one by one while comments column is longer
            do {
                $item = $comments.filter(':visible').last();
                if ($item.length === 0) {
                    break;
                }
                if (top + commentsHeight > contentBottom) {
                    commentsHeight -= $item.data('height');
                    $item.hide();
                    result--;
                } else {
                    break;
                }
            } while (true);
        } else if (commentsBottom < contentBottom) {
            // show elements one by one while comments column is shorter
            do {
                $item = $comments.filter(':hidden').first();
                if ($item.length === 0) {
                    break;
                }
                commentsHeight += $item.data('height');
                if (top + commentsHeight <= contentBottom) {
                    $item.show();
                    result++;
                } else {
                    break;
                }
            } while (true);
        }

        this.needsLoading = result >= 0;
        this.allVisible = $comments.filter(':hidden').length === 0;
        return result;
    }
}



// WEBPACK FOOTER //
// ./modules/blocks/last_comments/lastcomments.js